var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 44.8638C34 46.0266 33.0303 46.9963 31.8674 46.9963C30.7046 46.9963 29.7349 46.1214 29.7349 44.8638C29.7349 43.7009 30.7046 42.7312 31.8674 42.7312C33.0303 42.7312 34 43.7009 34 44.8638ZM33.1289 38.0715C33.1289 38.7495 32.5455 39.3329 31.8675 39.3329L31.8675 39.3333C31.1894 39.3333 30.6061 38.8484 30.6061 38.1704L30.6061 19.2613C30.6061 18.5832 31.1894 17.9999 31.8675 17.9999C32.5456 17.9999 33.1289 18.5833 33.1289 19.2613L33.1289 38.0715Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 15.4585 48.5415 2 32 2C15.4585 2 2 15.4585 2 32C2 48.5415 15.4585 62 32 62C48.5415 62 62 48.5415 62 32ZM4.7468 32C4.7468 17.7986 17.7986 4.7468 32 4.7468C46.2014 4.7468 59.2532 17.7986 59.2532 32C59.2532 46.2014 46.2014 59.2532 32 59.2532C17.7986 59.2532 4.7468 46.2014 4.7468 32Z",
    fill: "currentColor"
  })));
};
export default SvgIconWarning;